export class MsError {
    errorNumber: number;
    status: number;
    statusText: string;
    message: string;
    friendlyMessage: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/helpers/MsError.ts